// extracted by mini-css-extract-plugin
export default {"contentHolder":"Footer_contentHolder__0-eco","resContentHolder":"Footer_resContentHolder__Khha4"};